import React, { useContext, useState } from 'react';
import styles from './chevyPremiumPersonal.module.css';
import { CommonButton } from '~/common/components/CommonButton';
import { gtagEnvelope } from '~/common/util/gtagEnvelope';
import { Trial } from '~/common/pages/Trial/Trial';
import { CONTENT_IDS, TRIAL_TYPES } from '~/common/consts';
import { TrialContentProvider } from '~/common/provider/TrialContentProvider';
import { ModalContentContext } from '~/common/context/ContentContext';
import { useAppStore } from '~/common/store/appStore';
import { useShallow } from 'zustand/react/shallow';
import familiesCardBg from './families-card-bg.png';

const ChevyPremiumPersonal = () => {
  const { setContentId, trialType, setTrialType } = useAppStore(
    useShallow((state) => ({
      setContentId: state.setContentId,
      trialType: state.trialType,
      setTrialType: state.setTrialType,
    }))
  );
  const [currentStep, setCurrentStep] = useState<number>(0);
  const data = useContext(ModalContentContext);

  const handleCallback = (step: number) => {
    gtagEnvelope('event', 'cta_click', {
      cta_name: 'Step change',
      cta_position: `ChevyPremiumPersonal Trial Modal - Step ${step}`,
    });
    setCurrentStep(step);
  };

  const handlePersonalClick = () => {
    gtagEnvelope('event', 'cta_click', {
      cta_name: 'Next',
      cta_position: 'ChevyPremiumPersonal Trial Modal - Premium',
    });
    setContentId(CONTENT_IDS.PREMIUM);
    setTrialType(TRIAL_TYPES.PREMIUM);
    setCurrentStep(1);
  };

  const handleFamiliesClick = () => {
    gtagEnvelope('event', 'cta_click', {
      cta_name: 'Next',
      cta_position: 'ChevyPremiumPersonal Trial Modal - Families',
    });
    setContentId(CONTENT_IDS.FAMILIES);
    setTrialType(TRIAL_TYPES.FAMILIES);
    setCurrentStep(1);
  };

  if (!data) {
    return (
      <div className={styles['modal-cards']}>
        <div className={styles['modal-card']}>
          <div className={`${styles.contentLine} ${styles.contentLineImage}`}></div>
          <div className={styles['modal-card-copy']}>
            <div className={`${styles.contentLine} ${styles.contentLine28}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLine50}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLine50}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLineButton}`}></div>
          </div>
        </div>
        <div className={styles['modal-card']}>
          <div className={`${styles.contentLine} ${styles.contentLineImage}`}></div>
          <div className={styles['modal-card-copy']}>
            <div className={`${styles.contentLine} ${styles.contentLine28}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLine50}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLine50}`}></div>
            <div className={`${styles.contentLine} ${styles.contentLineButton}`}></div>
          </div>
        </div>
      </div>
    );
  }

  return currentStep === 0 ? (
    <div className={styles['modal-cards']}>
      <div className={styles['modal-card']}>
        <div className={styles['modal-card-illustration']}>
          <img src={data.card2?.image} alt="Personal illustration" />
        </div>
        <div className={styles['modal-card-copy']}>
          <h4>{data.card2?.title}</h4>
          <p>{data.card2?.text}</p>
          <CommonButton onClick={handlePersonalClick}>{data.card2?.button}</CommonButton>
        </div>
      </div>

      <div className={styles['modal-card']}>
        <div className={styles['modal-card-illustration']}>
          <img src="/-/media/8a8859b283c14b5ca4795cc92f4643fd.jpg" alt="Families illustration" />
        </div>
        <div className={styles['modal-card-copy']}>
          <h4>Families</h4>
          <p>6 Premium accounts for yourself and whoever you call family</p>
          <CommonButton onClick={handleFamiliesClick}>Try families free</CommonButton>
        </div>
      </div>
    </div>
  ) : (
    <div className={styles['modal-cols']}>
      <div className={styles['modal-col1']}>
        <TrialContentProvider>
          <Trial handleCallback={handleCallback} modalContent={data} />
        </TrialContentProvider>
      </div>
      <div
        className={styles['modal-col2']}
        style={trialType === TRIAL_TYPES.PREMIUM ? { backgroundColor: '#DEECDB' } : { backgroundColor: '#93C297' }}
      >
        <img
          src={
            trialType === TRIAL_TYPES.PREMIUM
              ? data.secondStep?.image2
              : '/-/media/f974d01c02834d188c962adde511b2bf.jpg'
          }
          alt="Trial"
        />
      </div>
    </div>
  );
};

export default ChevyPremiumPersonal;
